import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import ReportTab from "./ReportTab";
import ReportList from "./ReportList";
import ReportInfo from "./ReportInfo";
import ReportContext from "../Context/ReportContext";
import LoginInfoContext from "../Context/LoginInfoContext";
import {
    risk_list,
    getUserReportListAPI,
    getUserNewReportListAPI,
    vSystemType,
} from "../utils/GeneBoxAPI";

interface url {
    from: string;
    uid: string;
    version: string;
}

const Report = () => {
    const history = useHistory();
    const { from, uid, version }: url = useParams();
    const user_id = uid.toUpperCase();

    //context
    const { Provider } = ReportContext;
    const vUserListContext = useContext(ReportContext);
    const { vUserListContextData } = vUserListContext;
    const { sCurrentToken, sSystem, setbLoading, errorProcess } =
        useContext(LoginInfoContext);

    //state
    const [vUserListData, setUserListData] = useState(vUserListContextData);
    const [vUserRiskItem, setvUserRiskItem] = useState(
        vUserListContextData.item_list
    );
    const [nowSortType, setNowSortType] = useState<string>("");
    const [iSortNow, setSortNow] = useState<number>(1);
    const [tabPage, setTabPage] = useState("high_risk");
    const [bQuery, setbQuery] = useState(false);

    // get userList data
    const getUserListData = (user_id: string) => {
        setbLoading(true);
        setbQuery(true);
        const func =
            version === "3"
                ? getUserReportListAPI(user_id, sCurrentToken)
                : getUserNewReportListAPI(user_id);
        func.then((res) => {
            setUserListData(res);
        })
            .catch(() => {
                let url = "";
                const system = vSystemType[sSystem.current];
                if (from === "report_list") {
                    //特約醫生
                    const supplier = uid.split("").slice(0, 2).join("");
                    url = `/${from}/${supplier}/${system}`;
                } else {
                    url = `/${from}/${system}`;
                }
                history.push(url);
                errorProcess();
            })
            .finally(() => {
                setbLoading(false);
                setbQuery(false);
            });
    };

    useEffect(() => {
        getUserListData(user_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //filter user data
    useEffect(() => {
        //報告顯示 relation = 1 (高風險、中風險、一般風險、低風險) relation = 2 體質分析
        let item_type = tabPage !== "physique" ? 1 : 2;
        let risk_class =
            tabPage === "high_risk"
                ? 4
                : tabPage === "medium_risk"
                ? 3
                : tabPage === "general_risk"
                ? 2
                : tabPage === "low_risk"
                ? 1
                : 0;
        if (vUserListData.item_list !== undefined) {
            setvUserRiskItem(
                vUserListData.item_list.filter((item: risk_list) =>
                    item.relation !== 2
                        ? item.relation === item_type &&
                          item.risk_class === risk_class
                        : item.relation === item_type
                )
            );
        }
    }, [vUserListData, tabPage]);

    const vTabLi = [
        {
            text: "高風險項目",
            tabPageName: "high_risk",
            maincolor: "coralred",
        },
        {
            text: "中風險項目",
            tabPageName: "medium_risk",
            maincolor: "orange",
        },
        {
            text: "一般風險項目",
            tabPageName: "general_risk",
            maincolor: "green",
        },
        {
            text: "低風險項目",
            tabPageName: "low_risk",
            maincolor: "skyblue_1",
        },
        {
            text: "體質分析",
            tabPageName: "physique",
            maincolor: "grey",
        },
    ];

    const changeTapPage = (pageName: string) => {
        setTabPage(pageName);
        setNowSortType("");
    };

    const showComponent = () => {
        for (const vTab of vTabLi) {
            const { tabPageName, maincolor } = vTab;
            if (tabPage === tabPageName) {
                return (
                    <ReportList
                        tabPagename={tabPageName}
                        maincolor={maincolor}
                        version={version}
                    />
                );
            }
        }
    };

    // sort data
    const sortReportListData = (sortType: string): void => {
        let iSort = iSortNow;
        if (nowSortType !== sortType) {
            iSort = 1;
            setNowSortType(sortType);
        } else {
            iSort = -1 * iSort;
        }
        setvUserRiskItem(
            vUserRiskItem
                .sort((a: risk_list, b: risk_list) => {
                    if (sortType === "risk_value") {
                        let pre =
                            a[sortType] === "無變異"
                                ? -Infinity
                                : parseFloat(a[sortType]);
                        let next =
                            b[sortType] === "無變異"
                                ? -Infinity
                                : parseFloat(b[sortType]);
                        return (pre > next ? 1 : -1) * iSort;
                    } else {
                        return (a[sortType] > b[sortType] ? 1 : -1) * iSort;
                    }
                })
                .slice(0)
        );
        setSortNow(iSort);
    };

    // new context
    const vNewUserListContext = {
        ...vUserListContext,
        bQuery,
        vUserListContextData: vUserListData,
        iSortNow,
        nowSortType,
        vUserRiskItem,
        sortReportListData,
    };

    return (
        <div className="container tab_container">
            <Provider value={vNewUserListContext}>
                <ReportInfo />
                <ReportTab
                    tabPage={tabPage}
                    changePage={changeTapPage}
                    vTabLi={vTabLi}
                />
                <div className="tab_content_1">{showComponent()}</div>
            </Provider>
        </div>
    );
};

export default Report;
